import { useAuthStore } from "@shared/store/auth";

export function useCanViewCertificaciones(): boolean {
  return useAuthStore((state) =>
    Boolean(
      state.me?.permissions.includes("view-quality")
      || state.me?.permissions.includes("manage-quality"),
    ),
  );
}

export function useCanManageCertificaciones(): boolean {
  return useAuthStore((state) =>
    Boolean(state.me?.permissions.includes("manage-quality")),
  );
}

export function useCanSignNcpResponsable(): boolean {
  return useAuthStore((state) =>
    Boolean(state.me?.permissions.includes("sign-quality-ncp-responsable")),
  );
}

export function useCanSignNcpDireccion(): boolean {
  return useAuthStore((state) =>
    Boolean(state.me?.permissions.includes("sign-quality-ncp-direccion")),
  );
}
